import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { AccountStorage } from "@services/account";
var accountStorage = new AccountStorage();
var PayStatus = {
  0: "待付款",
  1: "已付款"
};
export default {
  data: function data() {
    return {
      id: "",
      base: {
        data: {}
      },
      table: {
        data: []
      },
      payment: {
        data: {
          payStatus: 0
        }
      },
      modalDetail: {
        show: false,
        data: []
      }
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var params, id;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _this.$route.params;
            id = params.id;
            _this.id = id;
            _context.next = 5;
            return _this.initDetailData();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  filters: {
    payStatusFilter: function payStatusFilter(status) {
      return PayStatus[status];
    }
  },
  methods: {
    goToPayment: function goToPayment() {
      this.$router.push({
        name: "payMent",
        query: {
          type: "bill"
        },
        params: {
          orderId: this.base.data.documentNo
        }
      });
    },
    modalDetailShow: function modalDetailShow() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.log(row);
      this.modalDetail.data = row.billDetailList || [];
      this.modalDetail.show = true;
    },
    formatTableData: function formatTableData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var userInfo = accountStorage.getCacheUserInfo();
      var remind = "否";
      if (!userInfo.normalStatus) {
        remind = "是";
      }
      return data.map(function (item) {
        item.remind = remind;
        return item;
      });
    },
    pullDetailData: function pullDetailData(id) {
      return this.$getHttpClient().post("/pjyy-deepexi-order-center/api/v1/bill/viewBill", {
        documentNo: id
      }).then(function (responses) {
        var data = responses.data;
        if (data.code === "200") {
          return data.data;
        }
        return;
      });
    },
    initDetailData: function initDetailData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.pullDetailData(_this2.id);
            case 2:
              result = _context2.sent;
              if (result) {
                _this2.base.data = result;
                _this2.table.data = _this2.formatTableData(result.billStatisticsList);
                result.payInfo && (_this2.payment.data = result.payInfo);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};